export const enum Scope {
  /**
   * Only consumed in local JS, never sent over the wire
   */
  Local = "local",
  /**
   * Sent to websocket server (-> other clients) but not saved to permanent
   * storage
   */
  Live = "live",
  /**
   * Sent to websocket server (-> other clients) and also saved to permanent
   * storage
   */
  Persist = "persist",
}
